import React, { useState, useMemo } from 'react';
import { FaLink, FaPlus, FaTrash, FaEdit, FaCopy, FaCheck, FaToggleOn, FaToggleOff, FaEnvelope } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import EditLinkModal from './EditLinkModal';

const GestionnaireLiens = ({ links = [], type, onCreate, onUpdate, onDelete, onSendReport, onSendAllReports }) => {
    const [showEditModal, setShowEditModal] = useState(false);
    const [linkToEdit, setLinkToEdit] = useState(null);
    const { t } = useTranslation();
    const [newLink, setNewLink] = useState({
        ambassadeur_prenom: '',
        ambassadeur_nom: '',
        ambassadeur_email: '',
        url_destination: '',
        code_court: '',
        valide_jusqu_a: ''
    });
    const [copiedLink, setCopiedLink] = useState(null); // To track which link's URL was copied
    const [searchTerm, setSearchTerm] = useState('');
    const [showCreateForm, setShowCreateForm] = useState(false); // New state for form visibility

    // Filter links based on the 'type' prop
    const filteredLinks = useMemo(() => {
        const lowerCaseSearchTerm = searchTerm.toLowerCase();
        return links.filter(link => 
            link.type_lien === type && 
            !link.est_supprime &&
            (
                link.ambassadeur_prenom.toLowerCase().includes(lowerCaseSearchTerm) ||
                link.ambassadeur_nom.toLowerCase().includes(lowerCaseSearchTerm) ||
                link.ambassadeur_email.toLowerCase().includes(lowerCaseSearchTerm)
            )
        );
    }, [links, type, searchTerm]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewLink(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let finalValideJusquA = newLink.valide_jusqu_a;
        if (finalValideJusquA) {
            const date = new Date(finalValideJusquA + 'T00:00:00Z');
            finalValideJusquA = date.toISOString();
        }
        onCreate({ ...newLink, type_lien: type, valide_jusqu_a: finalValideJusquA });
        // Reset form
        setNewLink({
            ambassadeur_prenom: '',
            ambassadeur_nom: '',
            ambassadeur_email: '',
            url_destination: '',
            code_court: '',
            valide_jusqu_a: ''
        });
        setShowCreateForm(false); // Hide form after submission
    };

    const handleCopy = (url) => {
        navigator.clipboard.writeText(url);
        setCopiedLink(url);
        setTimeout(() => setCopiedLink(null), 2000);
    };

    const handleToggleActive = (link) => {
        onUpdate(link.id, { est_actif: !link.est_actif });
    };

    const handleEditClick = (link) => {
        setLinkToEdit(link);
        setShowEditModal(true);
    };

    return (
        <div className="link-section" style={{ marginTop: "30px" }}>
            <h3>
                <FaLink />{" "}
                {type === "defaut"
                    ? "Gestion des Liens par Défaut"
                    : "Gestion des Liens Personnalisés"}
            </h3>
            <p>
                {type === "defaut"
                    ? "Créez et gérez les liens par défaut pour vos administrateurs."
                    : "Créez et gérez des liens personnalisés pour vos administrateurs."}
            </p>

            <div className="link-actions-top">
                <button
                    onClick={() => onSendAllReports(type)}
                    className="action-btn btn-email"
                >
                    <FaEnvelope /> Envoyer Tous les Rapports (
                    {type === "defaut" ? "Par Défaut" : "Personnalisés"})
                </button>

                {!showCreateForm && (
                    <button
                        onClick={() => setShowCreateForm(true)}
                        className="action-btn btn-create-new"
                    >
                        <FaPlus /> Créer un nouveau lien
                    </button>
                )}
            </div>

            {showCreateForm && (
                <form onSubmit={handleSubmit} className="link-form">
                    <h4>
                        Créer un nouveau lien (
                        {type === "defaut" ? "par Défaut" : "Personnalisé"})
                    </h4>
                    <div className="form-group">
                        <input
                            type="text"
                            name="ambassadeur_prenom"
                            value={newLink.ambassadeur_prenom}
                            onChange={handleInputChange}
                            placeholder="Prénom "
                            required
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="text"
                            name="ambassadeur_nom"
                            value={newLink.ambassadeur_nom}
                            onChange={handleInputChange}
                            placeholder="Nom"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="email"
                            name="ambassadeur_email"
                            value={newLink.ambassadeur_email}
                            onChange={handleInputChange}
                            placeholder="Email"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="text"
                            name="url_destination"
                            value={newLink.url_destination}
                            onChange={handleInputChange}
                            placeholder="URL de destination"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="text"
                            name="code_court"
                            value={newLink.code_court}
                            onChange={handleInputChange}
                            placeholder="Code court (ex: jean-dupont)"
                            required
                        />
                    </div>
                    {type === "personnalise" && (
                        <div className="form-group">
                            <input
                                type="date"
                                name="valide_jusqu_a"
                                value={newLink.valide_jusqu_a}
                                onChange={handleInputChange}
                                placeholder="Date de validité"
                                required
                            />
                        </div>
                    )}
                    <div className="form-actions">
                        <button type="submit">
                            <FaPlus /> Créer le lien
                        </button>
                        <button
                            type="button"
                            onClick={() => setShowCreateForm(false)}
                            className="action-btn btn-cancel"
                        >
                            Annuler
                        </button>
                    </div>
                </form>
            )}

            <div
                className="search-bar"
                style={{
                    marginBottom: "20px",
                    maxWidth: "400px",
                }}
            >
                <input
                    type="text"
                    placeholder="Rechercher par nom ou email..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ddd",
                    }}
                />
            </div>

            <div
                className="links-table-container"
                style={{ marginTop: "30px" }}
            >
                <h4>
                    Liste des liens (
                    {type === "defaut" ? "par Défaut" : "Personnalisés"}) (
                    {filteredLinks.length})
                </h4>
                <table>
                    <thead>
                        <tr>
                            <th>Ambassadeur</th>
                            <th>URL de Tracking</th>
                            <th>URL Destination</th>
                            <th>Clics</th>
                            {type === "personnalise" && (
                                <th>Valide jusqu'au</th>
                            )}
                            <th>Actif</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(filteredLinks || []).map((link) => (
                            <tr key={link.id}>
                                <td>
                                    {link.ambassadeur_prenom}{" "}
                                    {link.ambassadeur_nom} (
                                    {link.ambassadeur_email})
                                </td>
                                <td>
                                    {`https://gracedesalpes.com/r/${link.code_court}`}
                                </td>
                                <td>{link.url_destination}</td>
                                <td>{link.nombre_clics}</td>
                                {type === "personnalise" && (
                                    <td>
                                        {link.valide_jusqu_a
                                            ? link.valide_jusqu_a.split("T")[0]
                                            : "Permanent"}
                                    </td>
                                )}
                                <td>
                                    <button
                                        onClick={() => handleToggleActive(link)}
                                        className={`action-btn ${
                                            link.est_actif
                                                ? "btn-toggle-on"
                                                : "btn-toggle-off"
                                        }`}
                                        title={
                                            link.est_actif
                                                ? "Désactiver"
                                                : "Activer"
                                        }
                                    >
                                        {link.est_actif ? (
                                            <FaToggleOn />
                                        ) : (
                                            <FaToggleOff />
                                        )}{" "}
                                        {link.est_actif ? "Actif" : "Inactif"}
                                    </button>
                                </td>
                                <td className="action-cell">
                                    <button
                                        onClick={() => handleEditClick(link)}
                                        className="action-btn btn-edit"
                                        title="Modifier"
                                    >
                                        <FaEdit />
                                    </button>
                                    <button
                                        onClick={() => onDelete(link.id)}
                                        className="action-btn btn-delete"
                                        title="Supprimer"
                                    >
                                        <FaTrash />
                                    </button>
                                    <button
                                        onClick={() => onSendReport(link)}
                                        className="action-btn btn-report"
                                        title="Envoyer Rapport"
                                    >
                                        <FaEnvelope />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <EditLinkModal
                isOpen={showEditModal}
                onClose={() => setShowEditModal(false)}
                link={linkToEdit}
                onSave={onUpdate}
            />
        </div>
    );
};

export default GestionnaireLiens;